import React from 'react';
import './placements.css';
import placementData from '../../../pages/c2wHomePage/placements/placements.json';
import { useNavigate } from 'react-router';

function C2wPlacements() {
  const navigate = useNavigate();

  const items = placementData?.placements?.slice(0, 16) || [];
  // Duplicate list to achieve 100% seamless infinite marquee loop
  const marqueeItems = [...items, ...items];

  return (
    <section className="C2wPlacements_section">
      <div className="C2wPlacements_container">
        {/* Header Fold */}
        <div className="C2wPlacements_header">
          <h2 className="C2wPlacements_title">
            Our <span className="C2wPlacements_title_highlight">Top Placements</span>
          </h2>
          <p className="C2wPlacements_subtitle">
            <span className="highlight_accent">31000+ Students Placed</span> in <span className="highlight_accent">180+ Companies</span> • Real Success Stories
          </p>
        </div>

        {/* Custom Pure CSS Infinite Marquee Loop (No Slider Library) */}
        <div className="C2wPlacements_marquee_wrapper">
          <div className="C2wPlacements_marquee_fade left" />
          <div className="C2wPlacements_marquee_fade right" />
          
          <div className="C2wPlacements_marquee_track">
            {marqueeItems.map((item, index) => (
              <div
                key={index}
                className="C2wPlacements_marquee_card"
                onClick={() => navigate('/placements')}
              >
                <img
                  src={`/assets/images/placements/${item}`}
                  alt={`Placement Story ${index + 1}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Action Button */}
        <div className="C2wPlacements_btn_holder">
          <button
            className="C2wCoursesExploreBtn"
            onClick={() => navigate('/placements')}
            aria-label="View All Placements"
          >
            <span className="buttonText">All Placements</span>
            <div className="AnimatedButton">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12H23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 5L23 12L16 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <svg className="defaultArrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12H23" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16 5L23 12L16 19" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default C2wPlacements;
